import React, { useRef, useState } from "react";
import {
  useFloating,
  autoUpdate,
  offset,
  flip,
  shift,
  useClick,
  useDismiss,
  useRole,
  useInteractions,
  FloatingArrow,
  arrow,
  FloatingFocusManager
} from '@floating-ui/react';
import { ReactComponent as InfoIcon } from "../../images/info_grey.svg";
import './popover.scss'

export const Popover = ({ values }: any) => {
  const [isOpen, setIsOpen] = useState(false);
  const arrowRef = useRef(null);

  const { refs, floatingStyles, context } = useFloating({
    open: isOpen,
    placement: 'top',
    onOpenChange: setIsOpen,
    middleware: [offset(10), flip(), shift(), arrow({
      element: arrowRef,
    })],
    whileElementsMounted: autoUpdate,
  });

  const click = useClick(context);
  const dismiss = useDismiss(context, { ancestorScroll: true });
  const role = useRole(context);


  // Merge all the interactions into prop getters
  const { getReferenceProps, getFloatingProps } = useInteractions([
    click,
    dismiss,
    role,
  ]);

  return (
    <>
      <span ref={refs.setReference} {...getReferenceProps()}>
        <InfoIcon/>
      </span>
      {isOpen && (
        <FloatingFocusManager context={context} modal={false}>
          <div
            ref={refs.setFloating}
            className="popover"
            style={floatingStyles}
            {...getFloatingProps()}
          >
            <FloatingArrow fill={"#FFF"} strokeWidth={0.5} stroke={"#ddd"} ref={arrowRef} context={context} />
            {values}
          </div>
        </FloatingFocusManager>
      )}
    </>
  );
};
